module.exports = __webpack_public_path__ + "static/media/chad-fowler_200x200.7c2704d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/img/speakers/chad-fowler_200x200.png
// module id = 204
// module chunks = 0